<template>
	<Drawer :value="visible" title="批量回复" width="850" class-name="multiple-reply-comment-drawer"
		@on-close="handleClose">
		<div class="drawer-body">
			<div class="section-header">
				<span class="section-title">批量回复评价</span>
			</div>
			<div class="section-content">
				<span>已选择<span class="selected-count">{{ selectedItems.length }}条</span>评论，将统一发送以下回复内容</span>
			</div>
			<!-- 商家回复 -->
			<div class="merchant-reply">
				<div class="reply-label">商家回复</div>
				<div class="reply-input-container">
					<div class="reply-input-wrapper">
						<Input class="reply-input" v-model="merchantReplyText" type="textarea" :rows="4" placeholder="请输入回复内容"
							:maxlength="300" show-word-limit :border="false" style="border: none;" />
						<span class="limit-num">{{ merchantReplyText.length }}/300</span>
					</div>
					<div class="reply-tip">
						<span class="tip-dot">*</span>温馨提示：仅可回复评论一次，发表后不可修改
					</div>
				</div>
			</div>
		</div>
		<div class="drawer-footer">
			<Button type="error" class="footer-btn-confirm" @click="handleConfirm">确认回复</Button>
			<Button class="footer-btn-cancel" @click="handleClose">取消</Button>
		</div>
	</Drawer>
</template>

<script>
import { SaveShopReply } from "@/api/index";

export default {
	name: 'MultipleReplyCommentDrawer',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		selectedItems: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			merchantReplyText: '',
		}
	},
	methods: {
		handleClose() {
			this.$emit('update:visible', false)
			this.$emit('close');
			this.merchantReplyText = '';
		},
		handleConfirm() {
			console.log('selectedItems:', this.selectedItems);
			console.log('商家回复内容:', this.merchantReplyText);
			if (!this.merchantReplyText) {
				this.$Message.info('请输入回复内容');
				return;
			}
			SaveShopReply({
				uuids: this.selectedItems,
				content: this.merchantReplyText,
			}).then(res => {
				if (res.code === 0) {
					this.$Message.success('回复成功');
					this.handleClose();
					this.$emit('confirm');
				}
			});
		}
	}
}
</script>
<style lang="scss" scoped>
.drawer-body {
	display: flex;
	flex-direction: column;
	padding-bottom: 80px; // 给底部按钮留空间
	min-height: 100%;

	.section-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 13px;

		.section-title {
			font-weight: 400;
			font-size: 16px;
			line-height: 24px;
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}
	}

	.section-content {
		margin-bottom: 32px;
		font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		color: #333333;
		text-align: left;
		font-style: normal;
		text-transform: none;

		.selected-count {
			color: #FF5967;
		}
	}

	.merchant-reply {
		display: flex;
		gap: 15px;

		.reply-label {
			flex-shrink: 0;
			margin-top: 10px;
			font-weight: 400;
			font-size: 14px;
			line-height: 21px;
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;
		}

		.reply-input-container {
			width: 100%;
		}

		.reply-input-wrapper {
			width: 100%;
			margin-bottom: 8px;
			padding: 11px 16px 29px 16px;
			background: #FFFFFF;
			border-radius: 4px 4px 4px 4px;
			border: 1px solid #E3E3E3;
			position: relative;

			.reply-input {
				width: 100%;
				height: 100%;
				font-weight: 400;
				font-size: 12px;
				line-height: 18px;
				color: #333333;
				text-align: left;
				font-style: normal;
				text-transform: none;

				::v-deep textarea.ivu-input {
					border: none !important;
					box-shadow: none !important;

					:active,
					:focus {
						border: none !important;
						box-shadow: none !important;
					}
				}
			}

			.limit-num {
				position: absolute;
				bottom: 8px;
				right: 10px;
				font-weight: 400;
				font-size: 14px;
				line-height: 21px;
				color: #B3B3B3;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}

		}

		.reply-tip {
			font-weight: 400;
			font-size: 12px;
			line-height: 18px;
			color: #999999;
			text-align: left;
			font-style: normal;
			text-transform: none;

			.tip-dot {
				color: #FF5967;
				margin-right: 2px;
			}
		}
	}
}
</style>
<!-- 全局样式：覆盖 iView Drawer 默认内边距 -->
<style lang="scss">
.multiple-reply-comment-drawer {
	.ivu-drawer-header {
		border-bottom: 1px solid #e0e0e0;
		padding: 24px 32px 12px 32px;

		.ivu-drawer-header-inner {
			text-align: left;
			font-weight: bold;
			font-size: 18px;
			color: #0F1115;
			font-style: normal;
			text-transform: none;
		}
	}

	.ivu-drawer-body {
		padding: 24px !important;
		text-align: left;
	}

	.ivu-drawer-close {
		top: 16px;
		right: 20px;
		font-size: 20px;
		color: #999;

		&:hover {
			color: #333;
		}
	}
}

.drawer-footer {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 18px 16px 22px 70px;
	border-top: 1px solid #e8eaec;
	background: #fff;
	display: flex;
	justify-content: center;
	gap: 16px;
	z-index: 10;

	.footer-btn-confirm {
		width: 196px;
		height: 40px;
		background: #FF5967;
		border-radius: 4px 4px 4px 4px;
	}

	.footer-btn-cancel {
		width: 136px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #E3E3E3;
	}
}
</style>